export const fetchTrainingVideosData = async () => {
  try {
      const headers = new Headers({
          "cache-control": "max-age=172800"
      })
    const response = await fetch('./content/home/page-components/article/training-videos.json', {
        headers: headers
    });
    return await response.json();
  } catch (e) {
    console.log(e)
  }
};



// WEBPACK FOOTER //
// ./src/api/fetchTrainingVideosData.js